import {
  getEnvHeader,
  isExternal,
  isHelpcenter,
  isLarksuiteUnify,
  isLoginPage,
  isMacOS,
  isMobileDevice,
  isOpenApp,
  whichOsName,
  isLarkGroupTabEnv,
  isFeishuAppSidebar,
  isVa,
  isInternal,
} from '@meego/utils/src/platform/environment';
import { getAdaptConfigInFeishu } from '@meego/utils/src/platform/adaptInFeishu';
import { uuidGeneral } from '@meego/utils/src/tools/createUUID';
import { ProjectUtil } from '@meego/utils/src/storage/projectUtil';
import { getCookieDomain, GO_HOST, HOST, SLD } from '@meego/utils/src/constants/hosts';
import { updateGracefulDegradationFont } from '@meego/utils/src/styles/font';
import {
  SIMPLE_NAME_WHITE_LIST,
  SKIP_ASSET_URL_WHITE_LIST,
} from '@meego/utils/src/constants/exceptions';
import { CurLanguage, updateCurLanguage, isJa } from '@meego/utils/src/language/env/base';
import { initHookFunc } from '@meego/utils/src/tools/hookFunc';
import { registerFGOnErrorHook } from '@meego/models/src/query/fg/hooks/errorReporter.ts';
import { slardar } from '@meego/biz-utils/src/monitors/slardar';
import { LOCALSTORAGE_NODE_CRASH_PROTECTION } from '@meego/biz-utils/src/webStorage';
import { memoryMonitor } from '@meego/biz-utils/src/monitors/memoryMonitor/monitor';
import __i18next from '@meego/utils/src/i18next';

const clearCache = () => {
  import('react-router-cache-route').then(mod => mod.clearCache());
};

export {
  isMobileDevice,
  slardar,
  isHelpcenter,
  isOpenApp,
  isLoginPage,
  getAdaptConfigInFeishu,
  getEnvHeader,
  uuidGeneral,
  isMacOS,
  whichOsName,
  ProjectUtil,
  HOST,
  GO_HOST,
  SLD,
  isLarksuiteUnify,
  CurLanguage,
  isJa,
  updateCurLanguage,
  updateGracefulDegradationFont,
  isExternal,
  // monitor新增
  registerFGOnErrorHook,
  LOCALSTORAGE_NODE_CRASH_PROTECTION,
  initHookFunc,
  memoryMonitor,
  clearCache,
  SIMPLE_NAME_WHITE_LIST,
  SKIP_ASSET_URL_WHITE_LIST,
  isLarkGroupTabEnv,
  isFeishuAppSidebar,
  __i18next,
  isVa,
  getCookieDomain,
  isInternal,
};
